import { ACTION, useStore } from '@utils/event-store/useEventData';
import { typeMap } from '@component/EventDetailNav/hooks/useProgressOption';
import { useRouter } from 'next/router';
export const typesMap: { [key: string]: string } = {
  audience: 'audience',
  approval: 'approve',
  guest: 'guest',
  venue: 'venue',
  tickets: 'ticket',
  playback: 'playback',
  basic: 'basic',
  schedule: 'scheduler',
  register: 'register',
};
let set: string | number | NodeJS.Timeout | undefined = undefined;
const useProgressChange = () => {
  const { progressInfo, eventInfo, dispatch } = useStore();
  const { pathname } = useRouter();
  const changeData = (isEdit?: boolean, type?: string) => {
    let types = '';
    if (type) {
      types = type;
    } else {
      const typeArr = pathname.split('/');
      const name = typeArr[typeArr.length - 1];
      types = typesMap[name];
    }
    if (types && typeMap[types]?.type) {
      const status = progressInfo[typeMap[types].type];
      if (status !== isEdit || isEdit === undefined) {
        dispatch({
          type: ACTION.UPDATEPROGRESSINFO,
          data: {},
        });
      }
    }
  };
  const validateStatus = () => {
    dispatch({
      type: ACTION.UPDATEINFOREEDIRTSTATUS,
      data: eventInfo?.status === 1 ? 0 : 1,
    });
    if (eventInfo?.status === 1) {
      if (set) clearTimeout(set);
      set = setTimeout(() => {
        clearTimeout(set);
        dispatch({
          type: ACTION.UPDATEINFOREEDIRTSTATUS,
          data: 1,
        });
      }, 5 * 1000);
    }
  };
  return { progressInfo, changeData, validateStatus };
};

export default useProgressChange;
